import { envs } from '../core/services/envs';

export const TYPEFORM_MEETING_ENDED_ID = envs.VITE_TYPEFORM_MEETING_ENDED_ID || 'ftnTEeja';
export const TYPEFORM_EARLY_ACCESS_ID = 'gZ4Tb3Yf';
export const TYPEFORM_IN_MEETING_ID = envs.VITE_TYPEFORM_IN_MEETING_ID || 'BwxSvGel';
